var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions_root_div"},[_c('MainQuestions',{staticClass:"main_questions"}),_c('Side',{staticClass:"side_questions"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }